module.exports = __webpack_public_path__ + "static/media/jamb.4aa83145.png";